import { Reducer } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import {
  COMPANY_CONFIGURATION_REQUEST,
  COMPANY_CONFIGURATION_SUCCESSFUL,
  COMPANY_CONFIGURATION_FAILURE,
} from 'action-creators/companyConfiguration';
import { CompanyConfiguration } from 'models/company';

import { RESET } from '../action-creators/generic';

export interface CompanyConfigurationState {
  configuration: CompanyConfiguration | null;
  isLoading: boolean;
  error: string | null;
  saved: boolean;
  NationalAirBySector: boolean;
  InternationalAirBySector: boolean;
}

const initialState: CompanyConfigurationState = {
  configuration: null,
  isLoading: false,
  error: null,
  saved: false,
  NationalAirBySector: false,
  InternationalAirBySector: false
};

const reducer: Reducer<CompanyConfigurationState> = (state = initialState, action) => {
  switch (action.type) {
    case COMPANY_CONFIGURATION_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case COMPANY_CONFIGURATION_SUCCESSFUL: {
      return {
        ...state,
        configuration: action.payload.configuration,
        isLoading: false,
      };
    }
    case COMPANY_CONFIGURATION_FAILURE: {
      return {
        ...state,
        configuration: null,
        isLoading: false,
        error: action.payload,
      };
    }
    case RESET:
      return initialState;
    default:
      return state;
  }
};

const persistConfig = {
  storage,
  version: 1,
  key: 'companyConfiguration',
  blacklist: ['isLoading', 'error', 'saved'],
};

export default persistReducer(persistConfig, reducer);
